var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    className: "symbol",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Add compare function block") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 48,
    height: 48,
    fillOpacity: 0,
    stroke: "#000",
    strokeWidth: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 40,
    x2: 14,
    y2: 40,
    stroke: "#000",
    strokeWidth: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 40,
    x2: 80,
    y2: 40,
    stroke: "#000",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-20 -20 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    x2: 56,
    y1: 34,
    y2: 34,
    stroke: "black",
    strokeWidth: 6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    x2: 56,
    y1: 46,
    y2: 46,
    stroke: "black",
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-60 -20 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    x2: 28,
    y1: 40,
    y2: 26,
    stroke: "black",
    strokeWidth: 6
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    x2: 28,
    y1: 40,
    y2: 54,
    stroke: "black",
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-20 -60 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    x2: 52,
    y1: 40,
    y2: 26,
    stroke: "black",
    strokeWidth: 6
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    x2: 52,
    y1: 40,
    y2: 54,
    stroke: "black",
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-60 -60 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    x2: 56,
    y1: 34,
    y2: 34,
    stroke: "black",
    strokeWidth: 6
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    x2: 56,
    y1: 46,
    y2: 46,
    stroke: "black",
    strokeWidth: 6
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    x2: 48,
    y1: 56,
    y2: 24,
    stroke: "black",
    strokeWidth: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.c7c6a0fc6cdfac2d28e41eb4feb6e65e.svg";
export { ForwardRef as ReactComponent };